import { FC, memo } from "react";

interface Props {
  title: string;
  className?: string;
  backLink?: string;
  backLinkText?: string;
}

const LoginMainTitleBase: FC<Props> = ({ title, className }) => {
  const classNames = [
    "px-2 text-[22px] md:text-xl font-bold text-center",
    className,
  ].join(" ");

  return (
    <div className="pt-4 mb-[14px] space-y-4">
      <div className="h-6"></div>
      <h1 className={classNames}>{title}</h1>
    </div>
  );
};

export const LoginMainTitle = memo(LoginMainTitleBase);
